import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqItems } from '@/config/iphonefastflip';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 px-4 py-20 sm:py-24">
      <div className="mx-auto max-w-4xl">
        <div className="mb-12 text-center">
          <p className="section-eyebrow">FAQ</p>
          <h2 className="section-title">Najczęstsze pytania o iPhoneFastFlip.</h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => {
            const open = openIndex === index;
            return (
              <article key={item.question} className="overflow-hidden rounded-2xl border border-white/[0.08] bg-white/[0.025]">
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left sm:px-6"
                  aria-expanded={open}
                >
                  <span className="font-semibold text-white">{item.question}</span>
                  <motion.span animate={{ rotate: open ? 180 : 0 }} className="shrink-0 text-blue-300">
                    <ChevronDown className="h-5 w-5" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.22 }}
                    >
                      <p className="px-5 pb-5 text-sm leading-7 text-slate-400 sm:px-6 sm:pb-6">{item.answer}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
